// [고객화면 대리열람] 관리자 대리열람(impersonation) 세션 홀더.
//
// - BO(백오피스)가 iframe URL 쿼리(`?impersonationToken=...&readOnly=1`)로 주입한다.
// - 토큰을 공용 localStorage('bo-token')에 쓰지 않고 in-memory 로만 보관 → 실제 고객 세션과 격리.
//   (SPA 클라이언트 네비게이션 동안 메모리가 유지되므로 화면 이동 시에도 세션 유지)
// - impersonation === 읽기전용 이 원칙. readOnly=0 으로 명시할 때만 예외.
// - 읽기전용 강제(비-GET 차단)는 useAxios 중앙 가드에서 이 모듈을 참조해 수행한다.

let _session = null; // { token: string, readOnly: boolean }

// POST 지만 "조회"라서 읽기전용에서도 허용해야 하는 엔드포인트 (URL 부분일치).
// 참고: 파일/이미지 다운로드(downloadS3Image, fileDownload, downloadSecureS3Image)는
//       모두 axiosPostBlob 경유라 useAxios 가드 대상이 아님 → allowlist 불필요.
//       실제로 남는 "POST 조회"는 아래 하나뿐(스토리텔링 동적 질문 로드, array param 때문에 POST).
const READONLY_POST_ALLOWLIST = [
  "askFlow/mappingNames/cmFields",
];

export function setImpersonationSession(session) {
  if (session && session.token) {
    _session = { token: session.token, readOnly: session.readOnly !== false };
    // eslint-disable-next-line no-console
    console.log("[대리열람] 세션 설정됨. readOnly=", _session.readOnly);
  }
}

export function getImpersonationToken() {
  return _session ? _session.token : null;
}

export function isImpersonating() {
  return !!_session;
}

export function isReadOnly() {
  return !!_session && _session.readOnly;
}

// 읽기전용 모드에서 차단해야 하는 쓰기 호출인가? (allowlist 매칭 시 통과)
export function isWriteBlocked(url) {
  if (!isReadOnly()) return false;
  const u = String(url || "");
  return !READONLY_POST_ALLOWLIST.some((p) => u.includes(p));
}

// 앱 최초 로드 시 1회 호출 — URL 쿼리에서 주입 토큰을 파싱해 세션 설정.
export function initImpersonationFromUrl() {
  try {
    if (typeof window === "undefined") return;
    const params = new URLSearchParams(window.location.search);
    const token = params.get("impersonationToken");
    if (token) {
      const readOnly = params.get("readOnly") !== "0";
      setImpersonationSession({ token, readOnly });

      // [로그인 상태 주입] 앱의 로그인 판정은 localStorage 'bo-token'(→ JWT sub = bo-uid)을 본다.
      // 대리 토큰을 심어 "로그인된 고객"으로 인식시킨다. bo-uid(sub)가 채워지면
      // AuthContext 의 익명 자동발급도 스킵되어(early return) 세션이 익명으로 덮어써지지 않는다.
      // BO(backofficeadm)와 프론트(creditncity-c)는 다른 오리진이라, 이 iframe localStorage 는
      // 관리자 브라우저의 프론트 오리진 것 = 실제 고객과 격리된다.
      try {
        window.localStorage["bo-token"] = JSON.stringify({ accessToken: token, refreshToken: "" });
        window.localStorage["bo-utype"] = "google"; // 익명만 아니면 됨 (isAnonymous=false)
      } catch (e) {
        // eslint-disable-next-line no-console
        console.warn("[대리열람] bo-token 주입 실패", e);
      }
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn("[대리열람] initImpersonationFromUrl 실패", e);
  }
}
